import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-nx-dark bg-grid flex items-center justify-center px-6 font-jakarta" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="glass rounded-3xl p-8">
          <h1 className="font-syne text-2xl font-bold text-white">Recuperar senha</h1>
          {sent ? (
            <div className="mt-5" data-testid="forgot-success-message">
              <p className="text-sm text-zinc-300 leading-relaxed">
                Se o e-mail estiver cadastrado, você receberá um link de redefinição válido por 1 hora.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-5">
              <p className="text-sm text-zinc-400">Informe o e-mail da sua conta para receber o link de redefinição.</p>
              <div>
                <label htmlFor="forgot-email" className="text-xs font-mono uppercase tracking-widest text-zinc-400">E-mail</label>
                <input
                  id="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="mt-2 w-full bg-zinc-900/80 border border-zinc-700 focus:border-nx-yellow focus:outline-none rounded-xl px-4 py-3 text-sm text-white transition-colors"
                  placeholder="voce@empresa.com.br"
                />
              </div>
              {error && <p className="text-sm text-red-400" data-testid="forgot-error">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-button"
                className="w-full bg-nx-yellow text-nx-dark font-bold py-3.5 rounded-xl hover:bg-nx-electric transition-colors disabled:opacity-50"
              >
                {loading ? "Enviando..." : "Enviar link de redefinição"}
              </button>
            </form>
          )}
          <Link to="/login" className="block mt-6 text-xs text-nx-yellow hover:underline font-semibold" data-testid="back-to-login">
            ← Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}
